module.exports = __webpack_public_path__ + "img/percent.818722ce.png";